(() => {
  const destination = 'https://quote.createit3d.co.za/?source=createit3d-site';

  function normalizeProjectQuoteLinks(root = document) {
    root.querySelectorAll?.('a[href="#ci3d-project-quote"], a[href*="/pages/get-a-quote"]').forEach((link) => {
      link.href = destination;
      link.removeAttribute('target');
    });
  }

  const run = () => normalizeProjectQuoteLinks(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  window.addEventListener('load', run, { once: true });
  window.setTimeout(run, 800);
  window.setTimeout(run, 1800);

  const observer = new MutationObserver(run);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', (event) => {
    normalizeProjectQuoteLinks(event.target);
  });
})();
